import React from "react";
import styles from "./Presse.module.css";

interface PressItem {
  title: string;
  source: string;
  date: string;
  preview: string;
  href?: string;
  imageSrc?: string;
  imageAlt?: string;
  internal?: boolean;
}

const pressItems: PressItem[] = [
  {
    title: "DUOday meets Recken",
    source: "DUOday Hannover",
    date: "27.05.2026",
    preview:
      "DUOday bringt gelebte Inklusion in den Arbeitsalltag",
    href: "/presse/duoday-meets-recken",
    imageSrc: "/sponsors/dieRecken.png",
    imageAlt: "Logo Die Recken - TSV Hannover-Burgdorf",
    internal: true,
  },
  {
    title: "DUOday bringt Inklusion in Unternehmen voran",
    source: "Regionale Wirtschaftsnachrichten",
    date: "15.05.2026",
    preview:
      "Mehrere Unternehmen in der Region Hannover beteiligen sich am DUOday und schaffen neue Perspektiven für inklusives Arbeiten.",
    href: "https://example.com/news/duoday-inklusion",
    imageSrc: "/Archive/2025/DUO_Day-040.jpg",
    imageAlt: "Teilnehmende im Gesprach beim DUOday",
  },
  {
    title: "Stadt und Region setzen auf gelebte Teilhabe",
    source: "Hannover Lokal",
    date: "08.05.2026",
    preview:
      "Der Aktionstag zeigt, wie Begegnungen auf Augenhohe Beruhrungsangste abbauen und Chancen fur Menschen mit Beeintrachtigungen eroffnen.",
    href: "https://example.com/news/teilhabe-hannover",
    imageSrc: "/Archive/2025/DUO_Day-073.jpg",
    imageAlt: "Begegnung zwischen Mitarbeitenden und Teilnehmenden",
  },
  {
    title: "DUOday als Signal fur inklusive Arbeitswelt",
    source: "Sozialpolitik Heute",
    date: "29.04.2026",
    preview:
      "Expertinnen und Experten bewerten den DUOday als wirksames Format, um Unternehmen fur Vielfalt und inklusive Teams zu sensibilisieren.",
    href: "https://example.com/news/inklusive-arbeitswelt",
    imageSrc: "/Archive/2025/DuoDay-095.jpg",
    imageAlt: "Eindrucke aus einem DUOday-Unternehmen",
  },
];

export default function Presse() {
  const navigate = (event: React.MouseEvent, href: string) => {
    event.preventDefault();
    window.history.pushState({}, "", href);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <section className={styles.pressPage}>
      <header className={styles.header}>
        <h1>Presse</h1>
        <p>
          Hier finden Sie Vorschauen auf Berichte und Nachrichten von
          Drittanbietern rund um den DUOday.
        </p>
      </header>

      <div className={styles.grid}>
        {pressItems.map((item) => (
          <article key={`${item.source}-${item.title}`} className={styles.card}>
            <img
              src={item.imageSrc}
              alt={item.imageAlt}
              className={styles.image}
              loading="lazy"
            />
            <div className={styles.content}>
              <p className={styles.meta}>
                <span>{item.source}</span>
                <span>{item.date}</span>
              </p>
              <h2>{item.title}</h2>
              <p className={styles.preview}>{item.preview}</p>
              {item.href && (
                item.internal ? (
                  <a
                    href={item.href}
                    onClick={(event) => navigate(event, item.href as string)}
                    className={styles.link}
                  >
                    Beitrag ansehen
                  </a>
                ) : (
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
                  >
                    Beitrag ansehen
                  </a>
                )
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}